import React from "react";

export default function LocationIconRoundCircle({background = "#565656", color = "#FFF"}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g>
        <rect width="24" height="24" fill={background} rx="12"></rect>
        <path
          fill={color}
          d="M18.11 8.492a6.217 6.217 0 00-1.37-1.984 6.433 6.433 0 00-4.506-1.825c-.86 0-1.693.165-2.478.489a6.39 6.39 0 00-2.028 1.334 6.237 6.237 0 00-1.37 1.985 6.091 6.091 0 00-.504 2.435c0 1.211.29 2.417.859 3.58.458.935 1.098 1.845 1.904 2.712a15.317 15.317 0 003.231 2.624.754.754 0 00.769 0 15.315 15.315 0 003.231-2.624c.806-.865 1.446-1.777 1.904-2.712.573-1.161.863-2.366.863-3.578 0-.844-.17-1.664-.505-2.436zm-5.876 10.139c-1.13-.719-5.145-3.564-5.145-7.703 0-1.336.533-2.592 1.502-3.539a5.184 5.184 0 013.643-1.471c1.377 0 2.67.523 3.643 1.473.97.945 1.503 2.2 1.503 3.537 0 4.139-4.015 6.984-5.146 7.703zm0-10.586a3.019 3.019 0 100 6.037 3.019 3.019 0 000-6.037zm1.359 4.377a1.915 1.915 0 01-1.359.562A1.914 1.914 0 0110.46 11.8a1.914 1.914 0 01.417-2.094 1.907 1.907 0 011.358-.563c.513 0 .995.2 1.359.563.363.364.562.846.562 1.358 0 .513-.199.995-.562 1.359z"
        ></path>
      </g>
    </svg>
  );
}
